import api from "../api";

export const UseCreatePropertyType = (data) =>
    api.post("/property/type", data).then((res) => res.data);
